export default "__VITE_ASSET__ZYozIqKM__"